import { render, staticRenderFns } from "./calendar-lectures.vue?vue&type=template&id=40f7f088&"
import script from "./calendar-lectures.vue?vue&type=script&lang=js&"
export * from "./calendar-lectures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f7f088')) {
      api.createRecord('40f7f088', component.options)
    } else {
      api.reload('40f7f088', component.options)
    }
    module.hot.accept("./calendar-lectures.vue?vue&type=template&id=40f7f088&", function () {
      api.rerender('40f7f088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/calendar/calendar-lectures.vue"
export default component.exports